import type { Manager } from './interfaces/Initializable';

export abstract class ManagerBase implements Manager {
  private initialized = false;

  get isInitialized(): boolean {
    return this.initialized;
  }

  async initialize(): Promise<void> {
    if (this.initialized) {
      return;
    }

    await this.onInitialize();
    this.initialized = true;
  }

  async shutdown(): Promise<void> {
    if (!this.initialized) {
      return;
    }

    await this.onShutdown();
    this.initialized = false;
  }

  protected abstract onInitialize(): void | Promise<void>;

  protected abstract onShutdown(): void | Promise<void>;
}
